var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerusahaan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M28.0067 17.1013L13.001 21.9192V49.1125H47.6676V20.0763C47.6676 18.0545 45.6442 16.658 43.7539 17.3753L33.4209 21.2961C32.6278 21.5971 31.7788 21.0112 31.7788 20.1628V19.8519C31.7788 17.8935 29.8714 16.5027 28.0067 17.1013Z",
    fill: "#256AF5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12566",
    x: 18.7764,
    y: 24.5566,
    width: 5.77778,
    height: 5.77778,
    rx: 1.21212,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12568",
    x: 36.1094,
    y: 24.5566,
    width: 5.77778,
    height: 5.77778,
    rx: 1.21212,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12567",
    x: 18.7764,
    y: 36.1113,
    width: 5.77778,
    height: 5.77778,
    rx: 1.21212,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12569",
    x: 36.1094,
    y: 36.1113,
    width: 5.77778,
    height: 5.77778,
    rx: 1.21212,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54611 5.05664C4.87667 5.05664 4.33398 5.59932 4.33398 6.26876V9.61257H8.05319C8.4727 9.61257 8.81277 9.95265 8.81277 10.3721C8.81277 10.7917 8.4727 11.1317 8.05319 11.1317H4.33398V15.6921H8.05319C8.4727 15.6921 8.81277 16.0322 8.81277 16.4517C8.81277 16.8712 8.4727 17.2113 8.05319 17.2113H4.33398V49.1122H11.8052V6.26876C11.8052 5.59933 11.2626 5.05664 10.5931 5.05664H5.54611Z",
    fill: "#3BB56C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerusahaan);
export default __webpack_public_path__ + "static/media/perusahaan.7e560e6586d7e7cb126747ca0d330016.svg";
export { ForwardRef as ReactComponent };